import styles from "./addtuyaaccount.module.css";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { Button, FormControl, InputLabel, MenuItem, Select, TextField, Autocomplete } from "@mui/material";
import { useState, useEffect } from "react";
import { AddLogCallAPI } from "../../../../components/AddLogs";

const schema = yup.object().shape({
    type: yup.string().required("This field is Required"),
    property_id: yup.string().required("This field is Required"),
    apt_id: yup.string().when("type", (type) => {
        if (type && type === "Tuya")
            return yup.string().required("This field is Required").nullable();
        else
            return yup.string().nullable();
    }),
    name: yup.string().required("This field is Required"),
    email: yup.string().required("This field is Required"),
    project_id: yup.string().when("type", (type) => {
        if (type && type === "Tuya")
            return yup.string().required("This field is Required");
        else
            return yup.string();
    }),
    uid: yup.string().when("type", (type) => {
        if (type && type === "Tuya")
            return yup.string().required("This field is Required");
        else
            return yup.string();
    }),
    password: yup.string().when("type", (type) => {
        if (type && type === "TTLock")
            return yup.string().required("This field is Required");
        else
            return yup.string();
    }),
    client_id: yup.string().required("This field is Required"),
    client_secret: yup.string().required("This field is Required")
});

const EditTuyaAccount = ({ setShowTuyaAddFormNew, setLoading, setSnackbarMsg, setSnackbarOpen, onSubmitLocal, selectedData, propertyList }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [apartmentList, setApartmentList] = useState([]);
    const [selectedProperty, setSelectedProperty] = useState(0);
    const [iotType, setIotType] = useState('Tuya');

    const { handleSubmit, control, errors, setValue, clearErrors } = useForm({
        resolver: yupResolver(schema),
        mode: "onChange",
        defaultValues: {
            type: 'Tuya',
            property_id: '',
            apt_id: '',
            name: '',
            email: '',
            project_id: '',
            password: '',
            uid: '',
            client_id: '',
            client_secret: ''
        }
    });

    useEffect(() => {
        if (selectedData) {
            setIotType(selectedData?.type);
            setValue('type', selectedData?.type);
            setValue('property_id', selectedData?.property_id);
            setValue('name', selectedData?.name);
            setValue('email', selectedData?.email);
            setValue('uid', selectedData?.uid);
            setValue('project_id', selectedData?.project_id);
            setValue('client_id', selectedData?.client_id);
            setValue('client_secret', selectedData?.client_secret);

            setTimeout(() => {
                setValue('password', selectedData?.password);
            }, 500)


            let selProperty = propertyList?.filter(i => i.value === selectedData?.property_id);
            if (selProperty && selProperty.length > 0) {
                setApartmentList(selProperty[0].apartments);
            }
            setValue('apt_id', selectedData?.apt_id);
        }
    }, [selectedData, propertyList, setValue]);

    const selectProperty = (e) => {
        setSelectedProperty(e.target.value);
        let apartmentListTemp = [];
        let selProperty = propertyList?.filter(i => i.value === e.target.value);

        if (selProperty && selProperty.length > 0) {
            apartmentListTemp = selProperty[0].apartments;
        }

        setValue('apt_id', '');
        setApartmentList(apartmentListTemp);

        clearErrors();
    }

    const onSubmit = async (data) => {
        setSelectedProperty(0);
        setShowTuyaAddFormNew(false);
        setLoading(true);

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        axios.post(process.env.REACT_APP_DEVICE_API_URL + "v1/tuya-accounts/" + selectedData?.id, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setLoading(false);

            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            let rData = response.data.data;
            onSubmitLocal(rData);

            let logData = {
                'title': 'An IoT account has been updated',
                'description': [
                    'Project name: ' + rData?.name,
                    'Apartment: ' + rData?.property_name + ' - ' + rData?.apt_name
                ]
            }
            AddLogCallAPI(logData, token);

        }).catch((error) => {
            setLoading(false);
            if (typeof error.response !== "undefined")
                toast.error(error.response.data.message);
        });
    }

    return (<>
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className={`${styles.ReqAddRow}`}>
                <div className={`${styles.ReqAddFormSec}`}>
                    <div className={`${styles.FormSecRow}`}>
                        <div className={`${styles.FormHalfSec}`}>
                            <div className={`${styles.FormSec}`}>
                                <div className={`${styles.FormGroupFull} FormGroup`}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Type*</InputLabel>
                                        <Controller
                                            name="type"
                                            control={control}
                                            render={(field) => (
                                                <Select
                                                    label="Type*"
                                                    {...field}
                                                    onChange={(e) => {
                                                        field.onChange(e);
                                                        setIotType(e.target.value);
                                                    }}
                                                >
                                                    <MenuItem value={'Tuya'}>Tuya</MenuItem>
                                                    <MenuItem value={'TTLock'}>TTLock</MenuItem>
                                                </Select>
                                            )}
                                        />
                                    </FormControl>
                                    {errors.type && (<p className={`${styles.ErrorM}`}>{errors.type.message}</p>)}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.FormSecRow}`}>
                        <div className={`${styles.FormHalfSec}`}>
                            <div className={`${styles.FormSec}`}>
                                <div className={`${styles.FormGroupFull} FormGroup`}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Property*</InputLabel>
                                        <Controller
                                            name="property_id"
                                            control={control}
                                            render={(field) => (
                                                <Select
                                                    label="Property*"
                                                    {...field}
                                                    onChange={(e) => {
                                                        field.onChange(e);
                                                        selectProperty(e);
                                                    }}
                                                >
                                                    {propertyList?.map(i => {
                                                        return <MenuItem value={i?.value}>{i?.label}</MenuItem>
                                                    })}
                                                </Select>
                                            )}
                                        />
                                    </FormControl>
                                    {errors.property_id && (<p className={`${styles.ErrorM}`}>{errors.property_id.message}</p>)}
                                </div>
                            </div>
                        </div>
                        {iotType === 'Tuya' && <div className={`${styles.FormHalfSec}`}>
                            <div className={`${styles.FormSec}`}>
                                <div className={`${styles.FormGroupFull} FormGroup`}>
                                    <FormControl fullWidth>
                                        <Controller
                                            name="apt_id"
                                            control={control}
                                            render={(field) => (<Autocomplete
                                                options={apartmentList || []}
                                                getOptionLabel={(option) => option.label || ""}
                                                value={apartmentList?.find((opt) => opt.value === field.value) || null}
                                                renderInput={(params) => (<TextField {...params} label="Select Apartment*" />)}
                                                noOptionsText={selectedProperty ? "No apartments found" : "Select property first"}
                                                onChange={(event, newValue) => {
                                                    field.onChange(newValue?.value || null);
                                                    clearErrors("apt_id");
                                                }}
                                            />)}
                                        />
                                    </FormControl>
                                    {errors.apt_id && (<p className={`${styles.ErrorM}`}>{errors.apt_id.message}</p>)}
                                </div>
                            </div>
                        </div>}
                    </div>
                    <div className={`${styles.FormSecRow}`}>
                        <div className={`${styles.FormSec}`}>
                            <div className={`${styles.FormGroupFull} FormGroup`}>
                                <Controller
                                    name={`name`}
                                    control={control}
                                    render={(field) => (
                                        <TextField
                                            {...field}
                                            id="outlined-multiline-static"
                                            label="Project Name*"
                                            variant="outlined"
                                        />
                                    )}
                                />
                                {errors.name && (<p className={`${styles.ErrorM}`}>{errors?.name?.message}</p>)}
                            </div>
                        </div>
                        <div className={`${styles.FormSec}`}>
                            <div className={`${styles.FormGroupFull} FormGroup`}>
                                <Controller
                                    name={`email`}
                                    control={control}
                                    render={(field) => (
                                        <TextField
                                            {...field}
                                            id="outlined-multiline-static"
                                            label="Email*"
                                            variant="outlined"
                                        />
                                    )}
                                />
                                {errors.email && (<p className={`${styles.ErrorM}`}>{errors?.email?.message}</p>)}
                            </div>
                        </div>
                        {iotType === 'TTLock' && <div className={`${styles.FormSec}`}>
                            <div className={`${styles.FormGroupFull} FormGroup`}>
                                <Controller
                                    name={`password`}
                                    control={control}
                                    render={(field) => (
                                        <TextField
                                            {...field}
                                            id="outlined-multiline-static"
                                            label="Password*"
                                            variant="outlined"
                                        />
                                    )}
                                />
                                {errors.password && (<p className={`${styles.ErrorM}`}>{errors?.password?.message}</p>)}
                            </div>
                        </div>}
                    </div>
                    {iotType === 'Tuya' && <div className={`${styles.FormSecRow}`}>
                        <div className={`${styles.FormHalfSec}`}>
                            <div className={`${styles.FormSec}`}>
                                <div className={`${styles.FormGroupFull} FormGroup`}>
                                    <Controller
                                        name={`project_id`}
                                        control={control}
                                        render={(field) => (
                                            <TextField
                                                {...field}
                                                id="outlined-multiline-static"
                                                label="Project Code*"
                                                variant="outlined"
                                            />
                                        )}
                                    />
                                    {errors.project_id && (<p className={`${styles.ErrorM}`}>{errors?.project_id?.message}</p>)}
                                </div>
                            </div>
                        </div>
                        <div className={`${styles.FormHalfSec}`}>
                            <div className={`${styles.FormSec}`}>
                                <div className={`${styles.FormGroupFull} FormGroup`}>
                                    <Controller
                                        name={`uid`}
                                        control={control}
                                        render={(field) => (
                                            <TextField
                                                {...field}
                                                id="outlined-multiline-static"
                                                label="UID*"
                                                variant="outlined"
                                            />
                                        )}
                                    />
                                    {errors.uid && (<p className={`${styles.ErrorM}`}>{errors?.uid?.message}</p>)}
                                </div>
                            </div>
                        </div>
                    </div>}
                    <div className={`${styles.FormSecRow}`}>
                        <div className={`${styles.FormHalfSec}`}>
                            <div className={`${styles.FormSec}`}>
                                <div className={`${styles.FormGroupFull} FormGroup`}>
                                    <Controller
                                        name={`client_id`}
                                        control={control}
                                        render={(field) => (
                                            <TextField
                                                {...field}
                                                id="outlined-multiline-static"
                                                label={iotType === 'Tuya' ? "Access ID/Client ID*" : "Client ID*"}
                                                variant="outlined"
                                            />
                                        )}
                                    />
                                    {errors.client_id && (<p className={`${styles.ErrorM}`}>{errors?.client_id?.message}</p>)}
                                </div>
                            </div>
                        </div>
                        <div className={`${styles.FormHalfSec}`}>
                            <div className={`${styles.FormSec}`}>
                                <div className={`${styles.FormGroupFull} FormGroup`}>
                                    <Controller
                                        name={`client_secret`}
                                        control={control}
                                        render={(field) => (
                                            <TextField
                                                {...field}
                                                id="outlined-multiline-static"
                                                label={iotType === 'Tuya' ? "Access Secret/Client Secret*" : "Client Secret*"}
                                                variant="outlined"
                                            />
                                        )}
                                    />
                                    {errors.client_secret && (<p className={`${styles.ErrorM}`}>{errors?.client_secret?.message}</p>)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`${styles.ButtonAction}`}>
                <Button onClick={(e) => setShowTuyaAddFormNew(false)} type="button" className="CancelPopupBU">Cancel</Button>
                <Button type="submit" className="SubmitPopupBU">Update</Button>
            </div>
        </form>
    </>);
};

export default EditTuyaAccount;